// extracted by mini-css-extract-plugin
export default {"btn-upload":"BpFareTableManagementContainer_btn-upload__2kzvU","text-waring":"BpFareTableManagementContainer_text-waring__EFVqj"};